document.addEventListener('click', function (event) {
  if (event.target && event.target.id === 'qvSeeMoreBtn') {
    const seeMoreBtn = event.target;
    const descBox = seeMoreBtn.previousElementSibling; 

    if (descBox && descBox.classList.contains('qv-collapsed')) {
      descBox.classList.remove('qv-collapsed');
      descBox.classList.add('qv-expanded');
      const isFr = (document.documentElement.lang || 'en').startsWith('fr');
      seeMoreBtn.textContent = isFr ? 'Voir moins' : 'Read less';
    } else if (descBox) {
      descBox.classList.remove('qv-expanded');
      descBox.classList.add('qv-collapsed');
      const isFr = (document.documentElement.lang || 'en').startsWith('fr');
      seeMoreBtn.textContent = isFr ? 'Voir plus' : 'Read more';
    }
  }
});

function initQuickviewInnerFeatures() {
  const root = document.getElementById('quickview-root-container');
  if (!root) return;

  const thumbItems = root.querySelectorAll('.qv-thumb-item');

  // Initialize Isolated Swiper instance
  const swiperInstance = new Swiper(root.querySelector('.qv-swiper-engine'), {
    loop: true,
    navigation: { 
      nextEl: '#qvNavNext', 
      prevEl: '#qvNavPrev' 
    },
    observer: true, 
    observeParents: true,
    on: {
      slideChange: function () {
        const currentIndex = this.realIndex;
        thumbItems.forEach(thumb => thumb.classList.remove('active'));
        const activeThumb = root.querySelector(`.qv-thumb-item[data-thumb-index="${currentIndex}"]`);
        if (activeThumb) activeThumb.classList.add('active');
      }
    }
  });

  // Thumbnails Grid Event Triggers
  thumbItems.forEach(thumb => {
    thumb.addEventListener('click', (e) => {
      e.preventDefault(); e.stopPropagation();
      const targetIndex = parseInt(thumb.getAttribute('data-thumb-index'));
      swiperInstance.slideTo(targetIndex);
    });
  });

  const optionGroups = root.querySelectorAll('.qv-option-group');
  const cartSubmitBtn = document.getElementById('qvAddToCartSubmitBtn');
  const variantsJsonNode = document.getElementById('qvProductVariantsJson');
  const stockStatusNode = document.getElementById('qvStockStatus');
  
  if (!variantsJsonNode) return;
  const productVariants = JSON.parse(variantsJsonNode.textContent);

  let maxQty = Infinity;

  // Store initial button text dynamically based on what Liquid rendered (e.g., French/English)
  const initialCartBtnText = cartSubmitBtn ? cartSubmitBtn.textContent.trim() : "ADD TO CART";

  // Function to dynamically gray out out-of-stock swatches based on current combination
  function updateSwatchAvailability() {
    if (optionGroups.length <= 1) {
      // For single option products, directly check the variants
      optionGroups.forEach(group => {
        const buttons = group.querySelectorAll('.qv-swatch-item');
        buttons.forEach(btn => {
          const val = btn.getAttribute('data-value');
          const matched = productVariants.find(v => v.options[0] === val);
          if (matched && !matched.available) {
            btn.classList.add('disabled');
          } else {
            btn.classList.remove('disabled');
          }
        });
      });
      return;
    }

    // For multi-option products
    optionGroups.forEach((group, currentGroupIndex) => {
      const buttons = group.querySelectorAll('.qv-swatch-item');
      
      buttons.forEach(btn => {
        const val = btn.getAttribute('data-value');
        
        // Build a hypothetical combination if this button is pressed
        let testOptions = [];
        optionGroups.forEach((innerGroup, innerGroupIndex) => {
          if (innerGroupIndex === currentGroupIndex) {
            testOptions.push(val);
          } else {
            const activeBtn = innerGroup.querySelector('.qv-swatch-item.active');
            testOptions.push(activeBtn ? activeBtn.getAttribute('data-value') : null);
          }
        });

        // Look for any variant matching this option combination that is actually available
        const hasAvailableVariant = productVariants.some(variant => {
          return variant.options.every((optionVal, idx) => {
            return testOptions[idx] === null || optionVal === testOptions[idx];
          }) && variant.available;
        });

        if (!hasAvailableVariant) {
          btn.classList.add('disabled');
        } else {
          btn.classList.remove('disabled');
        }
      });
    });
  }

  // Variant checking logic processing module mapping
  function updateSelectedVariantInfo() {
    let selectedOptions = [];
    optionGroups.forEach(group => {
      const activeBtn = group.querySelector('.qv-swatch-item.active');
      if (activeBtn) selectedOptions.push(activeBtn.getAttribute('data-value'));
    });

    const matchedVariant = selectedOptions.length === 0
      ? productVariants[0]
      : productVariants.find(variant => {
          return variant.options.every((optionVal, index) => optionVal === selectedOptions[index]);
        });

    // Update maxQty based on variant inventory
    if (matchedVariant && matchedVariant.inventory_management === 'shopify' && matchedVariant.inventory_policy === 'deny') {
      maxQty = Math.max(0, matchedVariant.inventory_quantity);
    } else {
      maxQty = Infinity;
    }

    // 1. Handle Live Quantity Display & Text Status
    if (stockStatusNode) {
      const isFr = (document.documentElement.lang || 'en').startsWith('fr');
      const tracked = matchedVariant && matchedVariant.inventory_management === 'shopify';
      const qty = tracked ? matchedVariant.inventory_quantity : null;

      if (!matchedVariant || !matchedVariant.available) {
        stockStatusNode.textContent = isFr ? 'Rupture de stock' : 'Out of stock';
        stockStatusNode.className = 'qv-stock-status out-of-stock';
      } else if (qty === null) {
        stockStatusNode.textContent = isFr ? 'En stock' : 'In stock';
        stockStatusNode.className = 'qv-stock-status in-stock';
      } else if (qty <= 0) {
        stockStatusNode.textContent = isFr ? 'Rupture de stock' : 'Out of stock';
        stockStatusNode.className = 'qv-stock-status out-of-stock';
      } else if (qty === 1) {
        stockStatusNode.textContent = isFr ? 'Dernier en stock' : 'Last one in stock';
        stockStatusNode.className = 'qv-stock-status low-stock';
      } else if (qty <= 5) {
        stockStatusNode.textContent = isFr ? `Plus que ${qty} en stock` : `Only ${qty} left in stock`;
        stockStatusNode.className = 'qv-stock-status low-stock';
      } else {
        stockStatusNode.textContent = isFr ? `${qty} en stock` : `${qty} in stock`;
        stockStatusNode.className = 'qv-stock-status in-stock';
      }
    }

    // 2. Handle Add To Cart Button states
    if (matchedVariant && matchedVariant.available && cartSubmitBtn) {
      cartSubmitBtn.setAttribute('data-selected-variant-id', matchedVariant.id);
      cartSubmitBtn.removeAttribute('disabled');
      cartSubmitBtn.textContent = initialCartBtnText; // Restores original language text (e.g., TER AU PANIER or ADD TO CART)

      if (matchedVariant.featured_image) {
        const targetImgSrc = matchedVariant.featured_image.src;
        const slides = root.querySelectorAll('.swiper-slide');
        slides.forEach((slide, index) => {
          const slideImgUrl = slide.getAttribute('data-slide-img-src');
          if (slideImgUrl && targetImgSrc.includes(slideImgUrl)) {
            swiperInstance.slideTo(index);
          }
        });
      }
    } else if (cartSubmitBtn) {
      cartSubmitBtn.setAttribute('disabled', 'true');
      cartSubmitBtn.textContent = matchedVariant ? "OUT OF STOCK" : "UNAVAILABLE";
    }

    // Update out-of-stock visual swatches indicator states
    updateSwatchAvailability();
    updatePlusBtnState();
  }

  function updatePlusBtnState() {
    const plusBtn = document.getElementById('qvQtyPlus');
    const input = document.getElementById('qvQtyInput');
    if (!plusBtn || !input) return;
    plusBtn.classList.toggle('disabled', parseInt(input.value) >= maxQty);
  }

  optionGroups.forEach(group => {
    const buttons = group.querySelectorAll('.qv-swatch-item');
    buttons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        if (btn.classList.contains('disabled')) return; // Block click on disabled items

        buttons.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        updateSelectedVariantInfo();
      });
    });
  });

  // Initial Check on Load
  updateSelectedVariantInfo();

  const qtyInput = document.getElementById('qvQtyInput');
  const qtyPlusBtn = document.getElementById('qvQtyPlus');

  qtyPlusBtn?.addEventListener('click', (e) => {
    e.stopPropagation();
    if (qtyInput && parseInt(qtyInput.value) < maxQty) {
      qtyInput.value = parseInt(qtyInput.value) + 1;
      updatePlusBtnState();
    }
  });
  document.getElementById('qvQtyMinus')?.addEventListener('click', (e) => {
    e.stopPropagation();
    if (qtyInput && parseInt(qtyInput.value) > 1) {
      qtyInput.value = parseInt(qtyInput.value) - 1;
      updatePlusBtnState();
    }
  });

  // STRICT CLOSING METHOD WITH SCROLL UNLOCK
  const closeQuickviewPopupInstant = () => {
    document.body.style.overflow = ""; 
    root.style.display = 'none';
    root.innerHTML = "";
  };

  document.getElementById('qvMasterCloseBtn')?.addEventListener('click', (e) => {
    e.preventDefault(); e.stopPropagation();
    closeQuickviewPopupInstant();
  });

  root.querySelector('.qv-backdrop-wrapper')?.addEventListener('click', (e) => {
    if (!e.target.closest('.qv-modal-core')) {
      closeQuickviewPopupInstant();
    }
  });

  // Add to cart fetch trigger logic code block
  cartSubmitBtn?.addEventListener('click', (e) => {
    e.preventDefault(); e.stopPropagation();
    
    cartSubmitBtn.textContent = "ADDING...";
    cartSubmitBtn.setAttribute('disabled', 'true');

    const payloadItems = { id: cartSubmitBtn.getAttribute('data-selected-variant-id'), quantity: parseInt(qtyInput.value) };
    
    fetch('/cart/add.js', {
      method: 'POST', 
      headers: { 'Content-Type': 'application/json' }, 
      body: JSON.stringify({ items: [payloadItems] })
    })
    .then(res => res.json())
    .then((itemData) => {
      closeQuickviewPopupInstant();

      // Motion theme: 'ajaxProduct:added' makes the cart drawer rebuild (buildCart) AND open.
      // Without this, the drawer opens with stale content and the new item is not shown.
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        bubbles: true,
        detail: { product: itemData }
      }));

      // Legacy event kept for any other listeners
      document.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart: itemData }
      }));

      // Fallbacks for non-Motion setups (Dawn custom element, or cart_type = page)
      if (!(window.theme && theme.cart)) {
        const cartDrawerElement = document.querySelector('cart-drawer');
        if (cartDrawerElement && typeof cartDrawerElement.open === 'function') {
          cartDrawerElement.open();
        } else {
          const themeCartToggle = document.querySelector('[aria-controls="CartDrawer"]')
            || document.getElementById('cart-icon-bubble')
            || document.querySelector('.header__icon--cart');
          if (themeCartToggle) themeCartToggle.click();
        }
      }
    })
    .catch(err => {
      console.error(err);
      cartSubmitBtn.textContent = initialCartBtnText;
      cartSubmitBtn.removeAttribute('disabled');
    });
  });
}


function fetchQuickviewSectionData(productHandle, localeRoot = '') {
  const rootModalContainer = document.getElementById('quickview-root-container');
  if (!rootModalContainer || !productHandle) return;

  rootModalContainer.style.display = 'block';
  document.body.style.overflow = "hidden"; 
  rootModalContainer.innerHTML = '<div class="qv-backdrop-wrapper"><div class="qv-modal-core"><div class="qv-loading-placeholder">Loading Product Details...</div></div></div>';


  let cleanedLocale = localeRoot.trim();
  if (cleanedLocale === '/') {
    cleanedLocale = '';
  } else if (cleanedLocale.endsWith('/')) {
    cleanedLocale = cleanedLocale.slice(0, -1);
  }


  const fetchUrl = `${cleanedLocale}/products/${productHandle}?section_id=quickview-section`;

  fetch(fetchUrl)
    .then(response => response.text())
    .then(htmlMarkupString => {
      rootModalContainer.innerHTML = htmlMarkupString;
      initQuickviewInnerFeatures();
    })
    .catch(err => {
      console.error("Section API error:", err);
      document.body.style.overflow = ""; 
      rootModalContainer.style.display = 'none';
    });
}

// Global Click Trigger Module
window.addEventListener('click', function(e) {
  const targetedPlusBtn = e.target.closest('.custom_plus_icon_for_popup_child');
  if (targetedPlusBtn) {
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    const productHandle = targetedPlusBtn.getAttribute('data-product-handle');
    const localeRoot = targetedPlusBtn.getAttribute('data-locale-root') || ''; 
    
    if (productHandle) {
      fetchQuickviewSectionData(productHandle, localeRoot);
    }
  }
}, true);